'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECEIVE_HOME = exports.REQUEST_HOME = exports.RECEIVE_AGENTS = exports.REQUEST_AGENTS = undefined;
exports.fetchAgentsIfNeeded = fetchAgentsIfNeeded;

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var REQUEST_AGENTS = exports.REQUEST_AGENTS = 'REQUEST_AGENTS';
var RECEIVE_AGENTS = exports.RECEIVE_AGENTS = 'RECEIVE_AGENTS';
var REQUEST_HOME = exports.REQUEST_HOME = 'REQUEST_HOME';
var RECEIVE_HOME = exports.RECEIVE_HOME = 'RECEIVE_HOME';

function requestAgents(builderId) {
  return {
    type: REQUEST_AGENTS,
    builderId: builderId
  };
}

function receiveAgents(builderId, json) {
  return {
    type: RECEIVE_AGENTS,
    data: json.data._items,
    receivedAt: Date.now(),
    builderId: builderId
  };
}

function fetchAgents(builderId) {
  return function (dispatch) {
    dispatch(requestAgents(builderId));
    var request = new _bdcoreUtilities.BuilderCloud('agents', {
      max_results: 9999,
      where: {
        builder: builderId
      }
    });
    return request.getResource().then(function (json) {
      dispatch(receiveAgents(builderId, json));
    });
  };
}

function shouldFetchAgents(_ref, builderId) {
  var _ref$cloudData = _ref.cloudData;
  _ref$cloudData = _ref$cloudData === undefined ? {} : _ref$cloudData;
  var agents = _ref$cloudData.agents;

  var builderAgents = agents[builderId];

  if (!builderAgents) {
    return true;
  } else if (builderAgents.isFetching) {
    return false;
  } else if (!builderAgents.receivedAt) {
    return true;
  }

  return builderAgents.didInvalidate;
}

function fetchAgentsIfNeeded() {
  var builderId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _bdcoreUtilities.ConfigStore.getConfig('builder_id');

  return function (dispatch, getState) {
    if (shouldFetchAgents(getState(), builderId)) {
      return dispatch(fetchAgents(builderId));
    }
    return null;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Agents/actions.js
// module id = 482
// module chunks = 0